export const REGION_HEADER_NAME = 'X-Region'
export const CART_ID_HEADER_NAME = 'X-Cart-Id'
export const SCRF_TOKEN_HEADER_NAME = 'X-CSRF-TOKEN'
